module.exports = __webpack_public_path__ + "img/amex-card.1ee0f4b7.svg";